module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/viii.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "fm_chapter",
    attrs: {
      "id": "itr"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('strong', [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("My earliest memories, as a child, are of my father. I remember the aroma of his tomato sauce as it simmered on the stove, and spending mornings standing in his shadow to keep cool as he tended to the vegetables in our garden. Occasionally, my father would pick a ripe tomato or carrot, turn around, and offer it to me. I would scrunch up my nose and yell "), _c('em', [_vm._v("no grazie")]), _vm._v("! At the time, I didn’t like to eat my vegetables, like most small children. But years later, as I cook in my own kitchen, and take a bite out of a tomato from my own garden, the memories of those days bring a smile to my face. My family and memories of growing up in my hometown of Lucca, Italy inspired all the recipes in this book. Those memories, moments, laughter, and love are the main ingredients of my life—memories like waking up to the aroma of boiling milk and fresh warm cookies, which my mom, Laura, made for breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many times, while I’m cooking, I’m filled with ideas, and remember making fresh pasta like tagliatelle and lasagna with my grandma in our house in the mountains of Bologna. My grandma Rosita makes amazing simple Italian dishes to feed the family, including a delicious cake that I like to call "), _c('em', [_vm._v("Torta Rosita")]), _vm._v(", which makes everyone smile at holiday gatherings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other family members have influenced my cooking technique and knowledge. For example, a lot of the fish dishes and all the vegetarian recipes in this book are from my uncle Vincenzo and his wife Luana. I remember spending weekends with my uncle, making coffee and eating fresh fish from the waters of Massaciuccoli, where he owns a little house on the lake.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/ix.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _vm._v("Life in Tuscany was beautiful. I grew up in the middle of the countryside, outside the city, surrounded by vegetable gardens, fruit trees, and cornfields. We also had a barn for pigs and cows, and a chicken coop, where my brother and I used to gather warm eggs. We grew most of the food we used to make our meals. In the winter, we spent some time in a small village called Pianaccio, in a mountainous province of Bologna.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today, our home is on a creek with a small waterfall that rushes past the house. We have a beautiful garden with roses and fresh fruit trees. Next to the house, we keep a supply of wood to stoke our pizza oven and use in the kitchen stove and the fireplace in the living room. There’s a pantry below the kitchen, and all the bedrooms are upstairs. In front of the house, there’s a well of potable water that flows from the mountains, and our next-door neighbor, Romana, has taught me everything she knows about how to make and prepare pasta.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My experience growing up in Italy in the summertime was very different from the winter months. In fact my mom and dad sacrificed going out and buying things for themselves so that they could send my brother and me to live for three months in the summer with my grandma Liliana and her sister Magda in Lido Di Camaiore, on the coast of Lucca, which has a beautiful sandy beach. I remember arriving at the beginning of summer with pale skin and dark hair and leaving super tanned and with blond hair when it was time to go home. One of my greatest memories of that time is eating a lot of fresh fish and dining under a starry sky at night. My grandma and great aunt cooked for us while we were there, and one of the most amazing things they prepared was a vegetable dish, "), _c('em', [_vm._v("Sformato di Cavolfiore")]), _vm._v(", one of Magda’s creations, and which I didn’t recognize as cauliflower, a vegetable I did not like as a child. For me, she called the dish "), _c('em', [_vm._v("Torta di Verdure Croccante")]), _vm._v(", a rich, creamy vegetable cake with parmigiano, bread crumbs, and fresh milk. It had a wonderfully crispy texture that I couldn’t stop eating.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I came to America in 2009 with the dream of helping my family get a better life, and, after a few years of hard work, my brother Massimiliano joined me here, and we opened our first shop, Carrara Pastries, in Moorpark, California. Two years later, we opened another bakery in Agoura Hills.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Buon appetito!")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("DAMIANO CARRARA")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CEO PRESIDENT")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("CARRARA PASTRIES,Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "sans"
  }, [_vm._v("WWW.CARRARAPASTRIES.COM")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/xi.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1304bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926474_epub_itr_r1.vue
// module id = 72
// module chunks = 0